(function initializeLittleGPubSub() {
  if (window.__PUBSUB_INITIALIZED__) {
    return;
  }

  window.__PUBSUB_INITIALIZED__ = true;

  let subscribers = {};

  function subscribe(eventName, callback) {
    if (subscribers[eventName] === undefined) {
      subscribers[eventName] = [];
    }

    subscribers[eventName] = [...subscribers[eventName], callback];

    return function unsubscribe() {
      subscribers[eventName] = subscribers[eventName].filter((cb) => {
        return cb !== callback;
      });
    };
  }

  function publish(eventName, data) {
    if (subscribers[eventName]) {
      const promises = subscribers[eventName].map((callback) => {
        try {
          return Promise.resolve(callback(data));
        } catch (error) {
          return Promise.reject(error);
        }
      });

      return Promise.allSettled(promises);
    }

    return Promise.resolve();
  }

  // Global export for Dawn compatibility.
  window.subscribe = subscribe;
  window.publish = publish;
})();
